/**
 * Represents the marital status of a [[Member]].
 */
export var MemberMaritalStatus;
(function (MemberMaritalStatus) {
    /**
     * Not Specified
     */
    MemberMaritalStatus["NotSpecified"] = "NotSpecified";
    /**
     * Single
     */
    MemberMaritalStatus["Single"] = "Single";
    /**
     * Married
     */
    MemberMaritalStatus["Married"] = "Married";
    /**
     * Partnered
     */
    MemberMaritalStatus["Partnered"] = "Partnered";
    /**
     * Divorced
     */
    MemberMaritalStatus["Divorced"] = "Divorced";
    /**
     * Other
     */
    MemberMaritalStatus["Other"] = "Other";
})(MemberMaritalStatus || (MemberMaritalStatus = {}));
//# sourceMappingURL=member-marital-status.js.map